import { FormattedMessage, useIntl } from "react-intl";
import { Select } from "@/components/design/Select";
import type { DashboardContext } from "@/pages/project/dashboard-kinds";
import { ListingField } from "./ListingField";
import { listingSearchTarget, type ListingSearchTarget } from "./listing-search-target";

// Allein im Anlegen-Formular trägt das Select seinen eigenen Ring (`box`), wie Titel und Beschreibung daneben.
export function ListingSearchTargetSelect({ value, onChange, disabled = false, variant = "box" }: {
  value: ListingSearchTarget; onChange: (value: ListingSearchTarget) => void; disabled?: boolean; variant?: "box" | "plain";
}) {
  const intl = useIntl();
  return <ListingField label={<label htmlFor="listing-search-target"><FormattedMessage id="share.listings.searchTarget" /></label>}>
    <Select id="listing-search-target" value={value} disabled={disabled} hideEmpty variant={variant}
      options={[{ value: "PEOPLE", label: intl.formatMessage({ id: "share.listings.searchTarget.people" }) },
        { value: "COMPANIES", label: intl.formatMessage({ id: "share.listings.searchTarget.companies" }) }]}
      onChange={(next) => { if (next === "PEOPLE" || next === "COMPANIES") onChange(next); }} />
  </ListingField>;
}
export function ListingSearchTargetField({ ctx }: { ctx: DashboardContext }) {
  const target = listingSearchTarget(ctx.data);
  const locked = !ctx.entity.actions.canChangeSearchTarget;
  return <div>
    <ListingSearchTargetSelect value={target} disabled={ctx.readOnly || locked} variant="plain"
      onChange={(searchTarget) => ctx.editData({ searchTarget })} />
    {!ctx.readOnly && locked ? <p className="smycles-field-meta mt-1 text-ink-muted"><FormattedMessage id="share.listings.searchTarget.locked" /></p> : null}
  </div>;
}
